import React from "react";
import { FaEnvelope, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

const GetInTouch = () => {
  const contactCards = [
    {
      icon: <FaEnvelope className="text-[#00B4DB] text-xl" />,
      title: "Email",
      value: "parthadebnath466@gmail.com",
      link: "mailto:parthadebnath466@gmail.com",
    },
    {
      icon: <FaWhatsapp className="text-[#00B4DB] text-xl" />,
      title: "WhatsApp",
      value: "+91 9476316652",
      link: "https://wa.me/9476316652",
    },
    {
      icon: <FaPhoneAlt className="text-[#00B4DB] text-xl" />,
      title: "Phone",
      value: "+91 9476316652",
      link: "tel:+919476316652",
    },
    {
      icon: <FaMapMarkerAlt className="text-[#00B4DB] text-xl" />,
      title: "Location",
      value: "Kolkata, India (Open to Remote)",
      link: null,
    },
  ];

  return (
    <section
      name="contact"
      id="contact"
      className="relative w-full bg-[#0F172A] pt-20 pb-20 text-slate-100 overflow-hidden"
    >
      {/* Background Orbs */}
      <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-[#00B4DB]/12 rounded-full blur-[140px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="text-[#00B4DB] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full bg-[#00B4DB]/10 border border-[#00B4DB]/30">
            Let's Connect
          </span>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white mt-4 tracking-tight">
            Get In <span className="gradient-text">Touch</span>
          </h2>
          <p className="text-slate-400 text-sm sm:text-base mt-3 max-w-xl mx-auto">
            I am actively seeking full-time frontend / MERN stack developer roles. Have a project, job opening, or just want to say hi? Drop me a message!
          </p>
        </div>

        {/* Info Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {contactCards.map((card, idx) => (
            <div
              key={idx}
              className="bg-[#1E293B]/85 border border-slate-700/80 p-6 rounded-2xl flex flex-col items-center text-center group hover:border-[#00B4DB]/60 transition-all duration-300 hover:-translate-y-1 shadow-lg"
            >
              <div className="w-12 h-12 rounded-xl bg-slate-900 border border-slate-700/80 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:border-[#00B4DB]/50 transition-all">
                {card.icon}
              </div>
              <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-1">
                {card.title}
              </h3>
              {card.link ? (
                <a
                  href={card.link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm sm:text-base font-bold text-white hover:text-[#00B4DB] transition-colors break-all"
                >
                  {card.value}
                </a>
              ) : (
                <p className="text-sm sm:text-base font-bold text-white break-all">
                  {card.value}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
